var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, A11yText } from '@telus-uds/components-web';
import styled from 'styled-components';
import { FILTER_BUTTON_WIDTH } from '../helpers/constants';
var TabFilterButton = function (_a) {
    var item = _a.item, filterIndex = _a.filterIndex, tabsRef = _a.tabsRef, togglePanel = _a.togglePanel, tabList = _a.tabList, isSelected = _a.isSelected, isFocused = _a.isFocused, onFocus = _a.onFocus, onBlur = _a.onBlur, disableButtonWidth = _a.disableButtonWidth;
    var _b = useState(true), isFirstClick = _b[0], setIsFirstClick = _b[1];
    var updateScrollLeft = function (buttonIndex) {
        if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
            var scrollWidth = (tabsRef.current.scrollWidth / tabList.length) * buttonIndex;
            tabsRef.current.scrollLeft = scrollWidth;
        }
    };
    var buttonClick = function (e) {
        var _a;
        if (isFirstClick) {
            setIsFirstClick(false);
        }
        (_a = item === null || item === void 0 ? void 0 : item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
        togglePanel(item.id, filterIndex, item === null || item === void 0 ? void 0 : item.priceTierId);
        // scroll to the beginning of the tab.
        updateScrollLeft(filterIndex);
    };
    return (_jsx(StyledContainer, { onFocus: onFocus, onBlur: onBlur, "data-testid": "".concat(item.id, "-").concat(isSelected ? 'selected' : ''), isDisableButtonWidth: !!disableButtonWidth, children: _jsx(Button, { variant: { inverse: !isSelected }, tokens: __assign({ borderColor: 'black', color: 'white', borderRadius: '8px', width: disableButtonWidth ? '100%' : FILTER_BUTTON_WIDTH, height: '100%', paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '16px', borderBottomWidth: '1px', textAlign: 'left' }, (isFocused && { outerBorderColor: 'black' })), onPress: function (e) { return buttonClick(e); }, children: _jsxs(StyledFilterContent, { isSelected: isSelected, children: [item.component, " ", _jsx(A11yText, { text: item.id })] }) }) }));
};
export default TabFilterButton;
// --------------------------- STYLES --------------------------- //
var StyledFilterContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  p,\n  strong,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  ul,\n  ol,\n  li,\n  div,\n  span {\n    color: ", " !important;\n  }\n"], ["\n  p,\n  strong,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  ul,\n  ol,\n  li,\n  div,\n  span {\n    color: ", " !important;\n  }\n"])), function (props) { return (props.isSelected ? 'white' : 'black'); });
var StyledContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (props) { return (props.isDisableButtonWidth ? '50%' : 'auto'); });
var templateObject_1, templateObject_2;
